/* eslint-disable no-undef */

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import fetchData from "../../functions/fetchData";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { getHeaders } from "../../utility/getHeader";
import CardComponent from "../../components/cards/CardComponent";
import Header from "../../components/Header";
import Layout from "../../layout/Layout";
import { FaPrint, FaFileInvoice, FaMoneyCheckAlt, FaUserTie, FaCalendarAlt, FaWallet, FaCreditCard, FaEdit } from "react-icons/fa";
import { 
  Card, 
  Row, 
  Col, 
  Button, 
  Input, 
  Select, 
  DatePicker, 
  Table, 
  Tag, 
  Space,
  Statistic,
  Badge,
  Modal,
  Form,
  InputNumber,
  message
} from 'antd';
import {
  SearchOutlined,
  FilePdfOutlined,
  FileExcelOutlined,
  FilterOutlined,
  ReloadOutlined,
  EditOutlined,
  PrinterOutlined,
  CalendarOutlined,
  SaveOutlined,
  CloseOutlined,
  UserOutlined,
  DollarOutlined,
  BankOutlined,
  FileTextOutlined
} from '@ant-design/icons';
import { format as fmt } from "date-fns";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import "./paymentVouchers.css";

export default function PaymentVouchers() {
    const [suppliers, setsuppliers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [paymentDate, setPaymentDate] = useState(null);
    const [outstandingAmount, setOutstandingAmount] = useState(0);
    const [paymentAmount, setPaymentAmount] = useState("");
    const [paymentMode, setPaymentMode] = useState("");
    const [bankAccounts, setBankAccounts] = useState([]);
    const [selectedBankAccount, setSelectedBankAccount] = useState("");
    const [bankAccountId, setBankAccountId] = useState("");
    const [referenceNumber, setReferenceNumber] = useState("");
    const [chequeNumber, setChequeNumber] = useState("");
    const [remarks, setRemarks] = useState("");
    const [discountAmount, setDiscountAmount] = useState("");
    const [balanceAfterPayment, setBalanceAfterPayment] = useState(0);
    const [data, setData] = useState([]);
    const [companyInfo, setCompanyInfo] = useState({});
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [filterMode, setFilterMode] = useState("All");
    const [supplierSearchTerm, setSupplierSearchTerm] = useState("");
    const [showSupplierDropdown, setShowSupplierDropdown] = useState(false);
    const [highlightedSupplierIndex, setHighlightedSupplierIndex] = useState(-1);
    const [dateRange, setDateRange] = useState([null, null]);
    const [showFilters, setShowFilters] = useState(false);
    
    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    
    // Edit modal states
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingVoucher, setEditingVoucher] = useState(null);
    const [editForm] = Form.useForm();
    const [editFormData, setEditFormData] = useState({
        supplier_id: "",
        payment_date: "",
        amount: "",
        discount_amount: "",
        payment_mode: "",
        bank_account_id: "",
        reference_number: "",
        cheque_number: "",
        remarks: "",
        description: "",
        invoice_numbers: ""
    });
    
    // Payment modes with bank account requirement
    const paymentModes = [
        { value: "Cash", label: "Cash", requiresBank: false },
        { value: "Bank", label: "Bank Transfer", requiresBank: true },
        { value: "Credit_Card", label: "Credit Card", requiresBank: true },
        { value: "UPI", label: "UPI", requiresBank: true },
        { value: "Cheque", label: "Cheque", requiresBank: true },
        { value: "Online", label: "Online Payment", requiresBank: true }
    ];
    
    // Fetch suppliers, bank accounts and company info when component loads
    useEffect(() => {
        fetchData("supplier", setsuppliers, "id", {});
        fetchBankAccounts();
        fetchCompanyInfo();
    }, []);

    // Close supplier dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showSupplierDropdown && !event.target.closest('.form-group')) {
                setShowSupplierDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showSupplierDropdown]);

    const fetchBankAccounts = async () => {
        try {
            const res = await axios.get(`/bank-accounts`, getHeaders());
            if (res.data.success) {
                setBankAccounts(res.data.data || []);
            }
        } catch (error) {
            console.error('Error fetching bank accounts:', error);
        }
    };

    const fetchCompanyInfo = async () => {
        try {
            const companyData = await fetchData("company_profile", null, "id", {});
            if (companyData && companyData.length > 0) {
                setCompanyInfo(companyData[0]);
            }
        } catch (error) {
            console.error("Error fetching company info:", error);
        }
    };

    const getOutStandingBalance = async (e) => {
        const customerId = e.target.value;
        setSelectedCustomer(customerId); // Update selected customer state

        if (!customerId) {
            setOutstandingAmount(0);
            return;
        }

        try {
            const res = await axios.get(`/supplier-ledger-balance/${customerId}`, getHeaders());
            if (res.data.success) {
                // Use the balance from the API response
                const balance = res.data.data.balance || 0;
                setOutstandingAmount(Math.abs(balance)); // Show absolute value as outstanding amount
            } else {
                toast.error("Failed to fetch supplier outstanding balance");
            }
        } catch (error) {
            console.error("Error fetching outstanding balance:", error);
            toast.error("Error fetching outstanding balance.");
        }
    };

    useEffect(() => {
        const payment = parseFloat(paymentAmount) || 0;
        const discount = parseFloat(discountAmount) || 0;
        const totalPayment = payment + discount;
        const remaining = outstandingAmount - totalPayment;
        setBalanceAfterPayment(remaining >= 0 ? remaining : 0);
    }, [paymentAmount, outstandingAmount, discountAmount]);



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedCustomer || !paymentAmount || !paymentMode) {
            toast.error("Please fill in all required fields");
            return;
        }

        // Validate payment date
        if (!paymentDate) {
            toast.error("Please select payment date");
            return;
        }

        // Validate cheque number if payment mode is Cheque
        if (paymentMode === 'Cheque' && !chequeNumber) {
            toast.error("Please enter cheque number");
            return;
        }

        // Check if bank account is required but not selected
        const selectedMode = paymentModes.find(mode => mode.value === paymentMode);
        if (selectedMode && selectedMode.requiresBank && !bankAccountId) {
            toast.error('Please select bank account for this payment mode');
            return;
        }

        const paymentData = {
            supplier_id: selectedCustomer,
            amount: parseFloat(paymentAmount) || 0,
            discount_amount: parseFloat(discountAmount) || 0,
            reference_number: paymentMode === 'Cheque' ? chequeNumber : referenceNumber,
            cheque_number: paymentMode === 'Cheque' ? chequeNumber : null,
            payment_mode: paymentMode,
            bank_account_id: bankAccountId || null,
            description: remarks,
            payment_date: paymentDate ? paymentDate.format('YYYY-MM-DD') : new Date().toISOString().split('T')[0]
        };

        console.log('=== PAYMENT VOUCHER PAYLOAD DEBUG ===');
        console.log('Payment Date State:', paymentDate);
        console.log('Payment Date $d:', paymentDate ? paymentDate.$d : 'NULL');
        console.log('Formatted Date:', paymentDate ? paymentDate.format('YYYY-MM-DD') : 'NULL');
        console.log('voucher_date in payload:', paymentData.voucher_date);
        console.log('Complete Payload:', paymentData);
        console.log('=====================================');

        setLoading(true);
        try {
            const res = await axios.post(`/payment-vouchers`, paymentData, getHeaders());

            if (res.data.success) {
                toast.success("Payment voucher created successfully!");
                await fetchVoucherData();
                
                // Reset form
                setSelectedCustomer("");
                setSupplierSearchTerm("");
                setShowSupplierDropdown(false);
                setHighlightedSupplierIndex(-1);
                setPaymentDate(null);
                setPaymentAmount("");
                setDiscountAmount("");
                setPaymentMode("");
                setBankAccountId("");
                setReferenceNumber("");
                setChequeNumber("");
                setRemarks("");
                setOutstandingAmount(0);
                setBalanceAfterPayment(0);
            }
        } catch (error) {
            console.error("Error saving payment:", error);
            toast.error(`Error creating payment voucher: ${error?.response?.data?.message || error.message}`);
        } finally {
            setLoading(false);
        }
    };

    // Helper function to convert number to words
    const numberToWords = (num) => {
        if (num === 0) return "ศูนย์บาทถ้วน";
        
        const ones = ['', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'];
        const tens = ['', 'สิบ', 'ยี่สิบ', 'สามสิบ', 'สี่สิบ', 'ห้าสิบ', 'หกสิบ', 'เจ็ดสิบ', 'แปดสิบ', 'เก้าสิบ'];
        const positions = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน'];
        
        const [integerPart, decimalPart] = num.toFixed(2).split('.');
        let result = '';
        
        const integer = parseInt(integerPart);
        if (integer === 0) {
            result = 'ศูนย์บาท';
        } else {
            const intStr = integer.toString();
            const len = intStr.length;
            
            for (let i = 0; i < len; i++) {
                const digit = parseInt(intStr[i]);
                const pos = len - i - 1;
                
                if (digit !== 0) {
                    if (pos === 1 && digit === 1) {
                        result += 'สิบ';
                    } else if (pos === 1 && digit === 2) {
                        result += 'ยี่สิบ';
                    } else {
                        if (digit !== 0) result += ones[digit];
                        if (pos > 0) result += positions[pos];
                    }
                }
            }
            result += 'บาท';
        }
        
        const decimal = parseInt(decimalPart);
        if (decimal === 0) {
            result += 'ถ้วน';
        } else {
            result += decimal.toString() + 'สตางค์';
        }
        
        return result;
    };

    const handleEdit = (voucher) => {
        setEditingVoucher(voucher);
        editForm.setFieldsValue({
            supplier_id: voucher.supplier_id || "",
            payment_date: voucher.payment_date ? dayjs(voucher.payment_date) : null,
            amount: voucher.amount || "",
            discount_amount: voucher.discount_amount || "",
            payment_mode: voucher.payment_mode || "",
            bank_account_id: voucher.bank_account_id || "",
            reference_number: voucher.reference_id || "",
            cheque_number: voucher.cheque_number || "",
            remarks: voucher.remarks || "",
            description: voucher.description || "",
            invoice_numbers: voucher.invoice_numbers || ""
        });
        setShowEditModal(true);
    };

    const handleUpdateVoucher = async (values) => {
        if (!editingVoucher) return;
        
        const updateData = {
            supplier_id: values.supplier_id,
            supplier_name: suppliers.find(s => s.id === parseInt(values.supplier_id))?.name || editingVoucher.supplier_name,
            payment_date: values.payment_date ? values.payment_date.format('YYYY-MM-DD') : null,
            amount: parseFloat(values.amount),
            discount_amount: parseFloat(values.discount_amount) || 0,
            payment_mode: values.payment_mode,
            bank_account_id: values.bank_account_id || null,
            reference_number: values.reference_number || '',
            cheque_number: values.cheque_number || '',
            remarks: values.remarks || '',
            description: values.description || '',
            invoice_numbers: values.invoice_numbers || ''
        };
        
        setLoading(true);
        try {
            const response = await axios.put(
                `/payment-vouchers/${editingVoucher.id}`,
                updateData,
                getHeaders()
            );
            
            if (response.data.success) {
                message.success('Payment voucher updated successfully!');
                setShowEditModal(false);
                setEditingVoucher(null);
                editForm.resetFields();
                // Refresh the data
                const updatedData = await fetchData("payment_vouchers", null, "id", {});
                setData(updatedData);
            }
        } catch (error) {
            console.error('Error updating voucher:', error);
            message.error(error.response?.data?.message || 'Failed to update payment voucher');
        } finally {
            setLoading(false);
        }
    };

    const exportToPDF = () => {
        const doc = new jsPDF('landscape');
        const pageWidth = doc.internal.pageSize.getWidth();
        let currentY = 15;
        
        // Header
        doc.setFillColor(41, 128, 185);
        doc.rect(0, 0, pageWidth, 25, 'F');
        
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(16);
        doc.setFont(undefined, 'bold');
        doc.text('PAYMENT VOUCHERS REPORT', pageWidth / 2, currentY, { align: 'center' });
        
        doc.setFontSize(8);
        doc.setFont(undefined, 'normal');
        doc.text(`Generated: ${fmt(new Date(), "dd/MM/yyyy HH:mm")}`, pageWidth - 14, currentY, { align: 'right' });
        currentY = 30;
        
        doc.setTextColor(0, 0, 0);
        
        // Filter info
        if (dateRange[0] || dateRange[1] || filterMode !== 'All') {
            doc.setFillColor(240, 248, 255);
            doc.rect(5, currentY, pageWidth - 10, 14, 'F');
            currentY += 5;
            doc.setFontSize(9);
            doc.setFont(undefined, 'bold');
            doc.text('Filters:', 8, currentY);
            
            let filterText = [];
            if (dateRange[0] && dateRange[1]) {
                filterText.push(`Period: ${dayjs(dateRange[0]).format('DD/MM/YYYY')} to ${dayjs(dateRange[1]).format('DD/MM/YYYY')}`);
            }
            if (filterMode !== 'All') filterText.push(`Mode: ${filterMode}`);
            
            doc.setFont(undefined, 'normal');
            doc.text(filterText.join(' | '), 30, currentY);
            currentY += 12;
        }
        
        // Table
        const tableColumn = ["Voucher ID", "Supplier", "Date", "Mode", "Amount", "Discount", "Reference"];
        const tableRows = [];
        
        filteredData.forEach((item) => {
            const supplier = suppliers.find(s => s.id === parseInt(item.supplier_id));
            const supplierName = supplier ? supplier.name : `Supplier #${item.supplier_id}`;
            
            tableRows.push([
                `PV-${item.id}`,
                supplierName,
                new Date(item.payment_date).toLocaleDateString('en-GB'),
                item.payment_mode,
                `฿${parseFloat(item.amount || 0).toFixed(2)}`,
                `฿${parseFloat(item.discount_amount || 0).toFixed(2)}`,
                item.reference_id || '-'
            ]);
        });
        
        // Add total row
        const totalAmount = filteredData.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
        const totalDiscount = filteredData.reduce((sum, item) => sum + parseFloat(item.discount_amount || 0), 0);
        tableRows.push([
            { content: "TOTAL", colSpan: 4, styles: { halign: 'right', fontStyle: 'bold' } },
            `฿${totalAmount.toFixed(2)}`,
            `฿${totalDiscount.toFixed(2)}`,
            ''
        ]);
        
        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: currentY,
            margin: { left: 5, right: 5 },
            theme: "grid",
            headStyles: { 
                fillColor: [41, 128, 185],
                textColor: [255, 255, 255],
                fontSize: 9,
                fontStyle: 'bold',
                halign: 'center'
            },
            styles: { 
                fontSize: 8,
                cellPadding: 2
            },
            didParseCell: function(data) {
                if (data.row.index === tableRows.length - 1) {
                    data.cell.styles.fillColor = [240, 248, 255];
                    data.cell.styles.fontStyle = 'bold';
                }
            }
        });
        
        doc.save(`payment_vouchers_${fmt(new Date(), "ddMMyyyy_HHmmss")}.pdf`);
        toast.success("PDF exported successfully!");
    };

    const exportToExcel = () => {
        try {
            const excelData = [];
            
            excelData.push(['PAYMENT VOUCHERS REPORT']);
            excelData.push([]);
            excelData.push([`Generated: ${fmt(new Date(), "dd/MM/yyyy HH:mm")}`]);
            
            if (dateRange[0] || dateRange[1] || filterMode !== 'All') {
                excelData.push([]);
                excelData.push(['Filters:']);
                if (dateRange[0] && dateRange[1]) {
                    excelData.push([`Period: ${dayjs(dateRange[0]).format('DD/MM/YYYY')} to ${dayjs(dateRange[1]).format('DD/MM/YYYY')}`]);
                }
                if (filterMode !== 'All') excelData.push([`Mode: ${filterMode}`]);
            }
            
            excelData.push([]);
            excelData.push(['Voucher ID', 'Supplier', 'Date', 'Mode', 'Amount', 'Discount', 'Reference']);
            
            filteredData.forEach((item) => {
                const supplier = suppliers.find(s => s.id === parseInt(item.supplier_id));
                const supplierName = supplier ? supplier.name : `Supplier #${item.supplier_id}`;
                
                excelData.push([
                    `PV-${item.id}`,
                    supplierName,
                    new Date(item.payment_date).toLocaleDateString('en-GB'),
                    item.payment_mode,
                    parseFloat(item.amount || 0).toFixed(2),
                    parseFloat(item.discount_amount || 0).toFixed(2),
                    item.reference_id || '-'
                ]);
            });
            
            const totalAmount = filteredData.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
            const totalDiscount = filteredData.reduce((sum, item) => sum + parseFloat(item.discount_amount || 0), 0);
            excelData.push(['', '', '', 'TOTAL', totalAmount.toFixed(2), totalDiscount.toFixed(2), '']);
            
            const ws = XLSX.utils.aoa_to_sheet(excelData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Payment Vouchers');
            
            ws['!cols'] = [
                { wch: 15 },
                { wch: 25 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 20 }
            ];
            
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, `payment_vouchers_${fmt(new Date(), "ddMMyyyy_HHmmss")}.xlsx`);
            
            toast.success("Excel exported successfully!");
        } catch (error) {
            console.error('Error exporting to Excel:', error);
            toast.error("Failed to export Excel file");
        }
    };

    const handlePrintPaymentVoucher = async (voucherData) => {
        try {
            setLoading(true);
            
            // Get supplier details
            const supplier = suppliers.find(s => s.id === parseInt(voucherData.supplier_id));
            const supplierName = supplier ? supplier.name : 'N/A';
            const supplierAddress = supplier ? supplier.address || 'N/A' : 'N/A';
            const supplierPhone = supplier ? supplier.phone || 'N/A' : 'N/A';
            
            // Format date and time
            const paymentDate = new Date(voucherData.payment_date);
            const formattedDate = paymentDate.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            // Convert amount to Thai Baht text
            const amountValue = parseFloat(voucherData.amount || 0);
            const amountInText = numberToThaiText(amountValue);

            // Process logo - handle blob/base64/buffer
            let logoSrc = '';
            if (companyInfo.logo) {
                try {
                    let logoData;
                    
                    // Check if it's a Buffer-like object (from database BLOB)
                    if (companyInfo.logo.type === 'Buffer' && Array.isArray(companyInfo.logo.data)) {
                        // Convert Buffer array to base64
                        const uint8Array = new Uint8Array(companyInfo.logo.data);
                        let binary = '';
                        for (let i = 0; i < uint8Array.byteLength; i++) {
                            binary += String.fromCharCode(uint8Array[i]);
                        }
                        logoData = btoa(binary);
                        logoSrc = `data:${companyInfo.logo_type || 'image/png'};base64,${logoData}`;
                    } 
                    // Check if it's already a base64 string
                    else if (typeof companyInfo.logo === 'string') {
                        logoData = companyInfo.logo;
                        
                        if (logoData.startsWith('data:image')) {
                            // Already base64 with prefix
                            logoSrc = logoData;
                        } else if (logoData.startsWith('blob:')) {
                            // Blob URL
                            logoSrc = logoData;
                        } else {
                            // Assume it's base64 without prefix
                            logoSrc = `data:${companyInfo.logo_type || 'image/png'};base64,${logoData}`;
                        }
                    }
                } catch (error) {
                    console.error('Error processing logo:', error);
                    logoSrc = ''; // Fallback to no logo
                }
            }

            const printContent = `
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <title>Payment Voucher</title>
                    <style>
                        @page {
                            size: A4;
                            margin: 8mm;
                        }
                        
                        * {
                            margin: 0;
                            padding: 0;
                            box-sizing: border-box;
                        }
                        
                        body {
                            font-family: Arial, 'Sarabun', sans-serif;
                            font-size: 8pt;
                            line-height: 1.2;
                            color: #000;
                            background: white;
                        }
                        
                        .voucher-container {
                            max-width: 190mm;
                            height: 135mm;
                            margin: 0 auto;
                            padding: 4mm;
                            border: 1.5px solid #000;
                            background: linear-gradient(135deg, #fdfdfd 0%, #f8f9fa 100%);
                            display: flex;
                            flex-direction: column;
                        }
                        
                        /* Compact Header */
                        .header-section {
                            display: flex;
                            align-items: center;
                            margin-bottom: 6px;
                            padding-bottom: 6px;
                            border-bottom: 1px solid #000;
                            min-height: 25mm;
                            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
                            border-radius: 3px;
                            padding: 4px 6px;
                        }
                        
                        .logo-section {
                            flex: 0 0 40px;
                            margin-right: 8px;
                        }
                        
                        .logo-section img {
                            max-width: 115px;
                            max-height: 40px;
                            object-fit: contain;
                        }
                        
                        .company-info {
                            flex: 1;
                            font-size: 7pt;
                        }
                        
                        .company-name {
                            font-size: 9pt;
                            font-weight: bold;
                            margin-bottom: 2px;
                        }
                        
                        .voucher-title {
                            text-align: center;
                            font-size: 10pt;
                            font-weight: bold;
                            margin: 4px 0;
                            padding: 4px;
                            background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
                            border: 1px solid #2196f3;
                            border-radius: 3px;
                            color: #0d47a1;
                        }
                        
                        /* Two Column Layout */
                        .content-section {
                            display: flex;
                            gap: 8px;
                            flex: 1;
                            margin-bottom: 6px;
                        }
                        
                        .left-column, .right-column {
                            flex: 1;
                            font-size: 7pt;
                        }
                        
                        .info-group {
                            margin-bottom: 6px;
                            padding: 3px;
                            background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
                            border: 1px solid #ff9800;
                            border-radius: 3px;
                        }
                        
                        .info-group h4 {
                            font-size: 8pt;
                            font-weight: bold;
                            margin-bottom: 3px;
                            padding-bottom: 2px;
                            border-bottom: 1px solid #ff9800;
                            color: #e65100;
                        }
                        
                        .info-row {
                            display: flex;
                            margin-bottom: 2px;
                        }
                        
                        .info-label {
                            font-weight: bold;
                            min-width: 50px;
                            font-size: 6pt;
                        }
                        
                        .info-value {
                            flex: 1;
                            font-size: 7pt;
                        }
                        
                        /* Amount Section */
                        .amount-section {
                            background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%);
                            border: 1px solid #4caf50;
                            padding: 4px;
                            margin: 4px 0;
                            text-align: center;
                            border-radius: 3px;
                        }
                        
                        .amount-value {
                            font-size: 11pt;
                            font-weight: bold;
                            margin-bottom: 2px;
                        }
                        
                        .amount-words {
                            font-size: 6pt;
                            font-style: italic;
                        }
                        
                        /* Compact Table */
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 4px 0;
                            font-size: 6pt;
                        }
                        
                        table, th, td {
                            border: 1px solid #000;
                        }
                        
                        th {
                            background: #FCC4C4FF;
                            padding: 2px 4px;
                            text-align: center;
                            font-weight: bold;
                        }
                        
                        td {
                            padding: 2px 4px;
                            background: white;
                        }
                        
                        .text-center { text-align: center; }
                        .text-right { text-align: right; }
                        
                        /* Compact Signature */
                        .signature-section {
                            display: flex;
                            justify-content: space-between;
                            margin-top: 12px;
                            gap: 8px;
                            font-size: 7pt;
                        }
                        
                        .signature-box {
                            text-align: center;
                            flex: 1;
                            padding: 8px;
                            border: 1.5px solid #333;
                            background: linear-gradient(135deg, #A5CBF1FF 0%, #e9ecef 100%);
                            border-radius: 4px;
                            min-height: 35px;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                        }
                        
                        .signature-label {
                            font-weight: bold;
                            font-size: 6pt;
                            color: #333;
                            margin-bottom: 8px;
                            text-transform: uppercase;
                            letter-spacing: 0.5px;
                        }
                        
                        .signature-line {
                            border-top: 1.5px solid #333;
                            margin-top: 15px;
                            padding-top: 4px;
                            font-weight: bold;
                            font-size: 5pt;
                            color: #666;
                        }
                        
                        .footer-note {
                            font-size: 5pt;
                            text-align: center;
                            color: #666;
                            margin-top: 4px;
                            padding: 2px;
                        }
                        
                        @media print {
                            body { margin: 0; padding: 0; }
                            .voucher-container { 
                                border: 1.5px solid #000;
                                box-shadow: none;
                                page-break-inside: avoid;
                                background: #fdfdfd !important;
                            }
                            .header-section { background: #f5f5f5 !important; }
                            .voucher-title { 
                                background: #e8f4f8 !important;
                                color: #1565c0 !important;
                                border: 1px solid #333 !important;
                            }
                            .info-group { 
                                background: #faf5f0 !important;
                                border: 1px solid #333 !important;
                            }
                            .amount-section { 
                                background: #f0f8f0 !important;
                                border: 1px solid #333 !important;
                            }
                            th { background: #d8d8d8 !important; }
                            .signature-box { 
                                background: #f0f0f0 !important;
                                border: 1.5px solid #000 !important;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="voucher-container">
                        <!-- Compact Header -->
                        <div class="header-section">
                            ${logoSrc ? `
                            <div class="logo-section">
                                <img src="${logoSrc}" alt="Logo" />
                            </div>
                            ` : ''}
                            <div class="company-info">
                                <div class="company-name">${companyInfo.name || 'COMPANY NAME'}</div>
                                <div>
                                    ${companyInfo.address || 'Address'} | Tel: ${companyInfo.phone_number || 'Phone'}<br>
                                    Tax ID: ${companyInfo.tax_id || 'XXXXXXXXXXXXX'}
                                    ${companyInfo.email ? ` | ${companyInfo.email}` : ''}
                                </div>
                            </div>
                        </div>
                        
                        <div class="voucher-title">PAYMENT VOUCHER / ใบสำคัญจ่าย</div>
                        
                        <!-- Two Column Content -->
                        <div class="content-section">
                            <!-- Left Column -->
                            <div class="left-column">
                                <div class="info-group">
                                    <h4>Voucher Info</h4>
                                    <div class="info-row">
                                        <span class="info-label">No:</span>
                                        <span class="info-value">PV-${voucherData.id}</span>
                                    </div>
                                    <div class="info-row">
                                        <span class="info-label">Date:</span>
                                        <span class="info-value">${formattedDate}</span>
                                    </div>
                                    <div class="info-row">
                                        <span class="info-label">Mode:</span>
                                        <span class="info-value">${getPaymentModeInThai(voucherData.payment_mode)}</span>
                                    </div>
                                    ${voucherData.payment_mode === 'Cheque' && (voucherData.cheque_number || voucherData.reference_id) ? `
                                    <div class="info-row">
                                        <span class="info-label">Cheque:</span>
                                        <span class="info-value">${voucherData.cheque_number || voucherData.reference_id}</span>
                                    </div>
                                    ` : voucherData.reference_id ? `
                                    <div class="info-row">
                                        <span class="info-label">Ref:</span>
                                        <span class="info-value">${voucherData.reference_id}</span>
                                    </div>
                                    ` : ''}
                                </div>
                                
                                <div class="info-group">
                                    <h4>Supplier Details</h4>
                                    <div class="info-row">
                                        <span class="info-label">Name:</span>
                                        <span class="info-value">${supplierName}</span>
                                    </div>
                                    ${supplier && supplier.address ? `
                                    <div class="info-row">
                                        <span class="info-label">Addr:</span>
                                        <span class="info-value">${supplier.address}</span>
                                    </div>
                                    ` : ''}
                                    ${supplier && supplier.contact ? `
                                    <div class="info-row">
                                        <span class="info-label">Tel:</span>
                                        <span class="info-value">${supplier.contact}</span>
                                    </div>
                                    ` : ''}
                                </div>
                            </div>
                            
                            <!-- Right Column -->
                            <div class="right-column">
                                <div class="amount-section">
                                    <div class="amount-value">฿ ${parseFloat(voucherData.amount || 0).toLocaleString('th-TH', { minimumFractionDigits: 2 })}</div>
                                    <div class="amount-words">(${numberToWords(parseFloat(voucherData.amount || 0))})</div>
                                </div>
                                
                                ${voucherData.description || voucherData.remarks ? `
                                <div class="info-group">
                                    <h4>Description</h4>
                                    <div style="font-size: 6pt; line-height: 1.3;">
                                        ${(voucherData.description || voucherData.remarks || '').substring(0, 150)}${(voucherData.description || voucherData.remarks || '').length > 150 ? '...' : ''}
                                    </div>
                                </div>
                                ` : ''}
                                
                                <div class="info-group">
                                    <h4>Payment Details</h4>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th style="width: 45%;">Mode</th>
                                                <th style="width: 55%;">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="text-center">${getPaymentModeInThai(voucherData.payment_mode)}</td>
                                                <td class="text-center">฿ ${parseFloat(voucherData.amount || 0).toLocaleString('th-TH', { minimumFractionDigits: 2 })}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Enhanced Signatures Section -->
                        <div class="signature-section">
                            <div class="signature-box">
                                <div class="signature-label">Prepared By</div>
                                <div class="signature-line">ผู้จัดทำ</div>
                            </div>
                            <div class="signature-box">
                                <div class="signature-label">Approved By</div>
                                <div class="signature-line">ผู้อนุมัติ</div>
                            </div>
                            <div class="signature-box">
                                <div class="signature-label">Received By</div>
                                <div class="signature-line">ผู้รับ</div>
                            </div>
                        </div>
                        
                        <div class="footer-note">
                            Generated on ${new Date().toLocaleString('th-TH')} | System: ${companyInfo.name || 'POS System'}<br>
                            System developed by Cloudnet Softwares
                        </div>
                    </div>
                </body>
                </html>
            `;

              

            // Open print window
            const printWindow = window.open("", "_blank");
            printWindow.document.write(printContent);
            printWindow.document.close();

            printWindow.onload = () => {
                printWindow.focus();
                setTimeout(() => {
                    printWindow.print();
                    
                    // Auto-close window after printing or canceling
                    printWindow.onafterprint = () => {
                        printWindow.close();
                    };
                    
                    // Fallback: Close after 1 second if user cancels print dialog
                    setTimeout(() => {
                        if (!printWindow.closed) {
                            printWindow.close();
                        }
                    }, 1000);
                }, 250);
            };

            setLoading(false);
        } catch (error) {
            console.error("Error printing voucher:", error);
            toast.error("Error generating payment voucher");
            setLoading(false);
        }
    };

    // Helper function to format currency
    const formatCurrency = (amount) => {
        if (!amount || isNaN(amount)) return '฿ 0.00';
        return `฿ ${parseFloat(amount).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    // Helper function to convert payment mode to Thai
    const getPaymentModeInThai = (mode) => {
        const modes = {
            'Cash': 'เงินสด / Cash',
            'Bank': 'โอนเงินผ่านธนาคาร / Bank Transfer',
            'Cheque': 'เช็ค / Cheque',
            'Online': 'ชำระออนไลน์ / Online Payment'
        };
        return modes[mode] || mode;
    };

    // Helper function to convert number to Thai text
    const numberToThaiText = (number) => {
        const digits = ['ศูนย์', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'];
        const positions = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน'];
        
        if (number === 0) return 'ศูนย์บาทถ้วน';
        
        const [intPart, decPart] = number.toFixed(2).split('.');
        let result = '';
        
        // Convert integer part
        const intStr = intPart.toString();
        const len = intStr.length;
        
        for (let i = 0; i < len; i++) {
            const digit = parseInt(intStr[i]);
            const position = len - i - 1;
            
            if (digit === 0) continue;
            
            if (position === 1 && digit === 1) {
                result += 'สิบ';
            } else if (position === 1 && digit === 2) {
                result += 'ยี่สิบ';
            } else if (position === 0 && digit === 1 && len > 1) {
                result += 'เอ็ด';
            } else {
                result += digits[digit] + positions[position];
            }
        }
        
        result += 'บาท';
        
        // Convert decimal part
        if (parseInt(decPart) === 0) {
            result += 'ถ้วน';
        } else {
            const satangStr = decPart.toString();
            let satangText = '';
            
            for (let i = 0; i < satangStr.length; i++) {
                const digit = parseInt(satangStr[i]);
                const position = satangStr.length - i - 1;
                
                if (digit === 0 && position === 1) continue;
                
                if (position === 1 && digit === 1) {
                    satangText += 'สิบ';
                } else if (position === 1 && digit === 2) {
                    satangText += 'ยี่สิบ';
                } else if (position === 0 && digit === 1 && satangStr.length > 1) {
                    satangText += 'เอ็ด';
                } else {
                    satangText += digits[digit];
                    if (position === 1) satangText += 'สิบ';
                }
            }
            
            result += satangText + 'สตางค์';
        }
        
        return result;
    };
    const fetchVoucherData = async () => {
        try {
            setLoading(true);
            const vouchers = await fetchData("payment_vouchers", null, "id", {});
            // Sort by ID descending to show latest records first
            const sortedVouchers = (vouchers || []).sort((a, b) => b.id - a.id);
            setData(sortedVouchers);
        } catch (error) {
            console.error("Error fetching payment vouchers:", error);
            toast.error("Failed to load payment vouchers");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchAndSetData = async () => {
            try {
                await fetchVoucherData();
            } catch (error) {
                console.error("Error in useEffect:", error);
            }
        };

        fetchAndSetData();
    }, []);

    // Filter data based on search and filter mode
    const filteredData = data.filter(item => {
        const matchesSearch = 
            item.supplier_id?.toString().includes(searchTerm) ||
            item.amount?.toString().includes(searchTerm) ||
            item.reference_id?.toString().includes(searchTerm);
        
        const matchesFilter = filterMode === "All" || item.payment_mode === filterMode;
        
        // Date range filter
        let matchesDateRange = true;
        if (dateRange[0] && dateRange[1]) {
            const itemDate = dayjs(item.payment_date);
            const startDate = dayjs(dateRange[0]).startOf('day');
            const endDate = dayjs(dateRange[1]).endOf('day');
            matchesDateRange = itemDate.isBetween(startDate, endDate, null, '[]');
        }
        
        return matchesSearch && matchesFilter && matchesDateRange;
    });

    // Pagination calculations
    const totalRecords = filteredData.length;
    const totalPages = Math.ceil(totalRecords / recordsPerPage);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);

    // Reset to page 1 when filter changes
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm, filterMode, recordsPerPage, dateRange]);

    // Generate page numbers to display
    const getPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 5;
        
        if (totalPages <= maxPagesToShow) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage <= 3) {
                for (let i = 1; i <= maxPagesToShow; i++) {
                    pages.push(i);
                }
            } else if (currentPage >= totalPages - 2) {
                for (let i = totalPages - maxPagesToShow + 1; i <= totalPages; i++) {
                    pages.push(i);
                }
            } else {
                for (let i = currentPage - 2; i <= currentPage + 2; i++) {
                    pages.push(i);
                }
            }
        }
        return pages;
    };

    return (
        <Layout>
            <Header title="Payment Vouchers / ใบสำคัญจ่าย" />
            <ToastContainer />

            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <div style={{ 
                        backgroundColor: 'white', 
                        padding: '30px', 
                        borderRadius: '10px',
                        textAlign: 'center'
                    }}>
                        <div className="spinner-border text-warning mb-3" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div>Processing...</div>
                    </div>
                </div>
            )}

            <div className="row">
                {/* Left Panel - Payment Form */}
                <div className="col-lg-4 col-sm-12 mb-4">
                    <CardComponent title="Create Payment Voucher" headerColor="warning">
                        <form onSubmit={handleSubmit} className="payment-form">
                            {/* Payment Date */}
                            <div className="form-group mb-3">
                                <label className="form-label d-flex align-items-center">
                                    <FaCalendarAlt className="me-2" />
                                    Payment Date <span className="text-danger">*</span>
                                </label>
                                <DatePicker
                                    value={paymentDate}
                                    onChange={(date) => setPaymentDate(date)}
                                    format="DD/MM/YYYY"
                                    placeholder="Select payment date"
                                    style={{ width: '100%' }}
                                    className="form-control"
                                    required
                                />
                            </div>

                            {/* Supplier Selection */}
                            <div className="form-group mb-3">
                                <label className="form-label d-flex align-items-center">
                                    <FaUserTie className="me-2" />
                                    Supplier Name <span className="text-danger">*</span>
                                </label>
                                <div style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Type to search supplier..."
                                        value={supplierSearchTerm}
                                        onChange={(e) => {
                                            setSupplierSearchTerm(e.target.value);
                                            setShowSupplierDropdown(true);
                                            setHighlightedSupplierIndex(-1);
                                        }}
                                        onFocus={() => {
                                            setShowSupplierDropdown(true);
                                            setHighlightedSupplierIndex(-1);
                                        }}
                                        onBlur={() => {
                                            setTimeout(() => {
                                                const matchedSupplier = suppliers.find(
                                                    supplier => supplier.name.toLowerCase() === supplierSearchTerm.toLowerCase()
                                                );
                                                if (!matchedSupplier && supplierSearchTerm) {
                                                    setSupplierSearchTerm('');
                                                    setSelectedCustomer('');
                                                    toast.warning('Please select a supplier from the list');
                                                }
                                                setShowSupplierDropdown(false);
                                            }, 200);
                                        }}
                                        onKeyDown={(e) => {
                                            const filteredSuppliers = suppliers.filter(supplier => 
                                                supplier.name.toLowerCase().includes(supplierSearchTerm.toLowerCase())
                                            );
                                            
                                            if (e.key === 'ArrowDown') {
                                                e.preventDefault();
                                                setHighlightedSupplierIndex(prev => 
                                                    prev < filteredSuppliers.length - 1 ? prev + 1 : prev
                                                );
                                            } else if (e.key === 'ArrowUp') {
                                                e.preventDefault();
                                                setHighlightedSupplierIndex(prev => prev > 0 ? prev - 1 : -1);
                                            } else if (e.key === 'Enter' && highlightedSupplierIndex >= 0) {
                                                e.preventDefault();
                                                const supplier = filteredSuppliers[highlightedSupplierIndex];
                                                if (supplier) {
                                                    setSupplierSearchTerm(supplier.name);
                                                    setSelectedCustomer(supplier.id);
                                                    setShowSupplierDropdown(false);
                                                    setHighlightedSupplierIndex(-1);
                                                    getOutStandingBalance({ target: { value: supplier.id } });
                                                }
                                            } else if (e.key === 'Escape') {
                                                setShowSupplierDropdown(false);
                                                setHighlightedSupplierIndex(-1);
                                            }
                                        }}
                                        required={!selectedCustomer}
                                        autoComplete="off"
                                    />
                                    {showSupplierDropdown && (
                                        <div 
                                            style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                right: 0,
                                                maxHeight: '200px',
                                                overflowY: 'auto',
                                                backgroundColor: 'white',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                marginTop: '2px',
                                                zIndex: 1000,
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                            }}
                                        >
                                            {suppliers
                                                .filter(supplier => 
                                                    supplier.name.toLowerCase().includes(supplierSearchTerm.toLowerCase())
                                                )
                                                .map((supplier, index) => (
                                                    <div
                                                        key={supplier.id}
                                                        style={{
                                                            padding: '8px 12px',
                                                            cursor: 'pointer',
                                                            borderBottom: '1px solid #f0f0f0',
                                                            backgroundColor: index === highlightedSupplierIndex ? '#d1e7fd' : 
                                                                           selectedCustomer === supplier.id ? '#e3f2fd' : 'white'
                                                        }}
                                                        onMouseDown={(e) => {
                                                            e.preventDefault();
                                                            setSupplierSearchTerm(supplier.name);
                                                            setSelectedCustomer(supplier.id);
                                                            setShowSupplierDropdown(false);
                                                            setHighlightedSupplierIndex(-1);
                                                            getOutStandingBalance({ target: { value: supplier.id } });
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            setHighlightedSupplierIndex(index);
                                                        }}
                                                    >
                                                        {supplier.name}
                                                    </div>
                                                ))}
                                            {suppliers.filter(supplier => 
                                                supplier.name.toLowerCase().includes(supplierSearchTerm.toLowerCase())
                                            ).length === 0 && (
                                                <div style={{ padding: '8px 12px', color: '#999' }}>
                                                    No suppliers found
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Outstanding Amount */}
                            <div className="form-group mb-3">
                                <label className="form-label d-flex align-items-center">
                                    <FaMoneyCheckAlt className="me-2" />
                                    Outstanding Amount
                                </label>
                                <input 
                                    type="text" 
                                    value={`฿ ${outstandingAmount.toLocaleString('th-TH', { minimumFractionDigits: 2 })}`} 
                                    readOnly 
                                    className="form-control bg-light"
                                />
                            </div>

                            {/* Payment Mode */}
                            <div className="form-group mb-3">
                                <label className="form-label d-flex align-items-center">
                                    <FaWallet className="me-2" />
                                    Payment Mode <span className="text-danger">*</span>
                                </label>
                                <select 
                                    value={paymentMode} 
                                    onChange={(e) => {
                                        setPaymentMode(e.target.value);
                                        setBankAccountId(''); // Reset bank account when mode changes
                                    }} 
                                    className="form-control form-select"
                                    required
                                >
                                    <option value="">-- Select Payment Mode --</option>
                                    {paymentModes.map(mode => (
                                        <option key={mode.value} value={mode.value}>
                                            {mode.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Bank Account Selection - Only show when bank is required */}
                            {paymentMode && paymentModes.find(mode => mode.value === paymentMode)?.requiresBank && (
                                <div className="form-group mb-3">
                                    <label className="form-label d-flex align-items-center">
                                        <FaCreditCard className="me-2" />
                                        Bank Account <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        value={bankAccountId}
                                        onChange={(e) => setBankAccountId(e.target.value)}
                                        className="form-control form-select"
                                        required
                                    >
                                        <option value="">Select Bank Account</option>
                                        {bankAccounts.filter(acc => acc.is_active).map(account => (
                                            <option key={account.id} value={account.id}>
                                                {account.account_name} ({account.bank_name}) - {formatCurrency(account.current_balance)}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            {/* Amount Paid */}
                            <div className="form-group mb-3">
                                <label className="form-label d-flex align-items-center">
                                    <FaMoneyCheckAlt className="me-2" />
                                    Amount Paid <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="number"
                                    step="0.01"
                                    value={paymentAmount}
                                    onChange={(e) => setPaymentAmount(e.target.value)}
                                    className="form-control"
                                    placeholder="0.00"
                                    required
                                />
                            </div>

                            {/* Discount Amount */}
                            <div className="form-group mb-3">
                                <label className="form-label d-flex align-items-center">
                                    <span className="me-2">🏷️</span>
                                    Discount Amount (Optional)
                                </label>
                                <input
                                    type="number"
                                    step="0.01"
                                    value={discountAmount}
                                    onChange={(e) => setDiscountAmount(e.target.value)}
                                    className="form-control"
                                    placeholder="0.00"
                                />
                                <small className="text-muted d-block mt-1">
                                    💡 Discount given to supplier will reduce their outstanding balance
                                </small>
                            </div>

                            {/* Reference Number */}
                            {paymentMode !== 'Cheque' && (
                                <div className="form-group mb-3">
                                    <label className="form-label">
                                        Reference Number (Optional)
                                    </label>
                                    <input
                                        type="text"
                                        value={referenceNumber}
                                        onChange={(e) => setReferenceNumber(e.target.value)}
                                        className="form-control"
                                        placeholder="Enter reference number"
                                    />
                                </div>
                            )}

                            {/* Cheque Number - Only show when payment mode is Cheque */}
                            {paymentMode === 'Cheque' && (
                                <div className="form-group mb-3">
                                    <label className="form-label d-flex align-items-center">
                                        <FaCreditCard className="me-2" />
                                        Cheque Number <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={chequeNumber}
                                        onChange={(e) => setChequeNumber(e.target.value)}
                                        className="form-control"
                                        placeholder="Enter cheque number"
                                        required
                                    />
                                </div>
                            )}

                            {/* Remarks */}
                            <div className="form-group mb-3">
                                <label className="form-label">Remarks (Optional)</label>
                                <textarea 
                                    value={remarks} 
                                    onChange={(e) => setRemarks(e.target.value)} 
                                    className="form-control"
                                    rows="3"
                                    placeholder="Enter any additional notes"
                                />
                            </div>

                            {/* Balance After Payment */}
                            <div className="form-group mb-4">
                                <label className="form-label d-flex align-items-center">
                                    <FaMoneyCheckAlt className="me-2" />
                                    Balance After Payment
                                </label>
                                <input 
                                    type="text" 
                                    value={`฿ ${balanceAfterPayment.toLocaleString('th-TH', { minimumFractionDigits: 2 })}`} 
                                    readOnly 
                                    className={`form-control ${balanceAfterPayment > 0 ? 'bg-warning-custom' : 'bg-success-custom text-white'}`}
                                    style={{ fontWeight: 'bold' }}
                                />
                            </div>

                            {/* Submit Button */}
                            <button 
                                type="submit" 
                                className="btn btn-warning-gradient btn-lg w-100"
                                disabled={loading}
                            >
                                <FaFileInvoice className="me-2" />
                                {loading ? 'Processing...' : 'Save Payment'}
                            </button>
                        </form>
                    </CardComponent>
                </div>

                {/* Right Panel - Payment History Table */}
                <div className="col-lg-8 col-md-8 col-sm-12 mb-4">
                    <CardComponent title="Payment History" headerColor="warning">
                        {/* Ant Design Filter Bar */}
                        <Card style={{ marginBottom: 16 }}>
                            <Row gutter={[16, 16]}>
                                <Col xs={24} md={8}>
                                    <Input
                                        placeholder="Search by Supplier, Amount, Reference..."
                                        prefix={<SearchOutlined />}
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        allowClear
                                    />
                                </Col>
                                <Col xs={24} md={6}>
                                    <Select
                                        style={{ width: '100%' }}
                                        value={filterMode}
                                        onChange={(value) => setFilterMode(value)}
                                    >
                                        <Select.Option value="All">All Modes</Select.Option>
                                        <Select.Option value="Cash">💵 Cash</Select.Option>
                                        <Select.Option value="Bank">🏦 Bank</Select.Option>
                                        <Select.Option value="Cheque">📝 Cheque</Select.Option>
                                        <Select.Option value="Online">🌐 Online</Select.Option>
                                        <Select.Option value="UPI">📱 UPI</Select.Option>
                                    </Select>
                                </Col>
                                <Col xs={24} md={10}>
                                    <Space>
                                        <Button
                                            icon={<FilterOutlined />}
                                            onClick={() => setShowFilters(!showFilters)}
                                            type={showFilters ? 'primary' : 'default'}
                                        >
                                            Filters
                                        </Button>
                                        <Button
                                            icon={<FilePdfOutlined />}
                                            onClick={exportToPDF}
                                            danger
                                        >
                                            PDF
                                        </Button>
                                        <Button
                                            icon={<FileExcelOutlined />}
                                            onClick={exportToExcel}
                                            style={{ background: '#107c41', color: 'white', borderColor: '#107c41' }}
                                        >
                                            Excel
                                        </Button>
                                        <Button
                                            icon={<ReloadOutlined />}
                                            onClick={() => {
                                                setSearchTerm('');
                                                setFilterMode('All');
                                                setDateRange([null, null]);
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Space>
                                </Col>
                            </Row>

                            {showFilters && (
                                <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                                    <Col xs={24} md={12}>
                                        <div>
                                            <label style={{ display: 'block', marginBottom: 8 }}>
                                                <CalendarOutlined /> Date Range
                                            </label>
                                            <DatePicker.RangePicker
                                                style={{ width: '100%' }}
                                                value={dateRange}
                                                onChange={(dates) => setDateRange(dates)}
                                                format="DD/MM/YYYY"
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <div>
                                            <label style={{ display: 'block', marginBottom: 8 }}>
                                                Records Per Page
                                            </label>
                                            <Select
                                                style={{ width: '100%' }}
                                                value={recordsPerPage}
                                                onChange={(value) => setRecordsPerPage(value)}
                                            >
                                                <Select.Option value={5}>5 records</Select.Option>
                                                <Select.Option value={10}>10 records</Select.Option>
                                                <Select.Option value={25}>25 records</Select.Option>
                                                <Select.Option value={50}>50 records</Select.Option>
                                                <Select.Option value={100}>100 records</Select.Option>
                                            </Select>
                                        </div>
                                    </Col>
                                </Row>
                            )}
                        </Card>

                        {/* Summary Stats */}
                        <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                            <Col xs={12} md={8}>
                                <Card>
                                    <Statistic
                                        title="Total Records"
                                        value={filteredData.length}
                                        prefix={<Badge count={filteredData.length} showZero style={{ backgroundColor: '#52c41a' }} />}
                                    />
                                </Card>
                            </Col>
                            <Col xs={12} md={8}>
                                <Card>
                                    <Statistic
                                        title="Total Amount"
                                        value={filteredData.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)}
                                        precision={2}
                                        prefix="฿"
                                        valueStyle={{ color: '#cf1322' }}
                                    />
                                </Card>
                            </Col>
                            <Col xs={12} md={8}>
                                <Card>
                                    <Statistic
                                        title="Total Discount"
                                        value={filteredData.reduce((sum, item) => sum + parseFloat(item.discount_amount || 0), 0)}
                                        precision={2}
                                        prefix="฿"
                                        valueStyle={{ color: '#3f8600' }}
                                    />
                                </Card>
                            </Col>
                        </Row>

                        {/* Search and Filter Section */}
                        <div className="row mb-3" style={{ display: 'none' }}>
                            <div className="col-md-3 mb-2">
                                <select
                                    className="form-control form-select"
                                    value={recordsPerPage}
                                    onChange={(e) => setRecordsPerPage(Number(e.target.value))}
                                >
                                    <option value={5}>5 records</option>
                                    <option value={10}>10 records</option>
                                    <option value={25}>25 records</option>
                                    <option value={50}>50 records</option>
                                    <option value={100}>100 records</option>
                                </select>
                            </div>
                            <div className="col-md-5 mb-2">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="🔍 Search by Supplier ID, Amount, Reference ID..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            <div className="col-md-4 mb-2">
                                <select
                                    className="form-control form-select"
                                    value={filterMode}
                                    onChange={(e) => setFilterMode(e.target.value)}
                                >
                                    <option value="All">All Payment Modes</option>
                                    <option value="Cash">Cash</option>
                                    <option value="Bank">Bank</option>
                                    <option value="Cheque">Cheque</option>
                                    <option value="Online">Online</option>
                                </select>
                            </div>
                        </div>

                        {/* Table */}
                        <Table
                            dataSource={currentRecords}
                            rowKey={(record) => record.id}
                            pagination={false}
                            scroll={{ x: 1200 }}
                            bordered
                            size="middle"
                            columns={[
                                {
                                    title: 'Voucher ID',
                                    dataIndex: 'id',
                                    key: 'id',
                                    width: 120,
                                    render: (id) => <strong>PV-{id}</strong>,
                                    sorter: (a, b) => a.id - b.id,
                                    defaultSortOrder: 'descend'
                                },
                                {
                                    title: 'Supplier',
                                    dataIndex: 'supplier_id',
                                    key: 'supplier',
                                    width: 200,
                                    render: (supplier_id) => {
                                        const supplier = suppliers.find(s => s.id === parseInt(supplier_id));
                                        return supplier ? supplier.name : `Supplier #${supplier_id}`;
                                    },
                                    sorter: (a, b) => {
                                        const supplierA = suppliers.find(s => s.id === parseInt(a.supplier_id))?.name || '';
                                        const supplierB = suppliers.find(s => s.id === parseInt(b.supplier_id))?.name || '';
                                        return supplierA.localeCompare(supplierB);
                                    }
                                },
                                {
                                    title: 'Date',
                                    dataIndex: 'payment_date',
                                    key: 'payment_date',
                                    width: 150,
                                    render: (date) => new Date(date).toLocaleDateString('en-GB'),
                                    sorter: (a, b) => new Date(a.payment_date) - new Date(b.payment_date)
                                },
                                {
                                    title: 'Mode',
                                    dataIndex: 'payment_mode',
                                    key: 'payment_mode',
                                    width: 120,
                                    render: (mode) => {
                                        const colors = {
                                            'Cash': 'success',
                                            'Bank': 'processing',
                                            'Cheque': 'warning',
                                            'UPI': 'cyan',
                                            'Online': 'blue'
                                        };
                                        return <Tag color={colors[mode] || 'default'}>{mode}</Tag>;
                                    },
                                    sorter: (a, b) => (a.payment_mode || '').localeCompare(b.payment_mode || '')
                                },
                                {
                                    title: 'Amount',
                                    dataIndex: 'amount',
                                    key: 'amount',
                                    width: 150,
                                    align: 'right',
                                    render: (amount) => (
                                        <strong style={{ color: '#cf1322' }}>
                                            ฿{parseFloat(amount || 0).toLocaleString('th-TH', { minimumFractionDigits: 2 })}
                                        </strong>
                                    ),
                                    sorter: (a, b) => parseFloat(a.amount || 0) - parseFloat(b.amount || 0)
                                },
                                {
                                    title: 'Discount',
                                    dataIndex: 'discount_amount',
                                    key: 'discount_amount',
                                    width: 120,
                                    align: 'right',
                                    render: (amount) => (
                                        <span style={{ color: '#3f8600' }}>
                                            ฿{parseFloat(amount || 0).toLocaleString('th-TH', { minimumFractionDigits: 2 })}
                                        </span>
                                    ),
                                    sorter: (a, b) => parseFloat(a.discount_amount || 0) - parseFloat(b.discount_amount || 0)
                                },
                                {
                                    title: 'Reference',
                                    dataIndex: 'reference_id',
                                    key: 'reference_id',
                                    width: 150,
                                    render: (ref, record) => {
                                        if (record.payment_mode === 'Cheque') {
                                            return record.cheque_number || ref || '-';
                                        }
                                        return ref || '-';
                                    }
                                },
                                {
                                    title: 'Action',
                                    key: 'action',
                                    width: 120,
                                    align: 'center',
                                    fixed: 'right',
                                    render: (_, record) => (
                                        <Space>
                                            <Button
                                                type="primary"
                                                icon={<EditOutlined />}
                                                size="small"
                                                onClick={() => handleEdit(record)}
                                                title="Edit Payment Voucher"
                                            />
                                            <Button
                                                danger
                                                icon={<PrinterOutlined />}
                                                size="small"
                                                onClick={() => handlePrintPaymentVoucher(record)}
                                                title="Print Payment Voucher"
                                            />
                                        </Space>
                                    )
                                }
                            ]}
                        />

                        {/* Pagination Controls */}
                        {filteredData.length > 0 && (
                            <div className="d-flex justify-content-between align-items-center mt-3 mb-3" style={{
                                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                                padding: '10px 15px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}>
                                <div className="text-muted" style={{ fontSize: '13px', fontWeight: '500' }}>
                                    Showing {indexOfFirstRecord + 1} to {Math.min(indexOfLastRecord, totalRecords)} of {totalRecords} records
                                </div>
                                <div>
                                    <nav>
                                        <ul className="pagination mb-0" style={{ gap: '4px' }}>
                                            {/* First Button */}
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <button 
                                                    className="page-link"
                                                    onClick={() => setCurrentPage(1)}
                                                    disabled={currentPage === 1}
                                                    style={{
                                                        padding: '4px 10px',
                                                        fontSize: '12px',
                                                        borderRadius: '5px',
                                                        border: '1px solid #dee2e6',
                                                        background: currentPage === 1 ? '#e9ecef' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                        color: currentPage === 1 ? '#6c757d' : 'white',
                                                        fontWeight: '500',
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                >
                                                    First
                                                </button>
                                            </li>
                                            
                                            {/* Previous Button */}
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <button 
                                                    className="page-link"
                                                    onClick={() => setCurrentPage(currentPage - 1)}
                                                    disabled={currentPage === 1}
                                                    style={{
                                                        padding: '4px 10px',
                                                        fontSize: '12px',
                                                        borderRadius: '5px',
                                                        border: '1px solid #dee2e6',
                                                        background: currentPage === 1 ? '#e9ecef' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                        color: currentPage === 1 ? '#6c757d' : 'white',
                                                        fontWeight: '500',
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                >
                                                    Prev
                                                </button>
                                            </li>
                                            
                                            {/* Page Numbers */}
                                            {getPageNumbers().map(pageNum => (
                                                <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                                                    <button 
                                                        className="page-link"
                                                        onClick={() => setCurrentPage(pageNum)}
                                                        style={{
                                                            padding: '4px 10px',
                                                            fontSize: '12px',
                                                            borderRadius: '5px',
                                                            border: '1px solid #dee2e6',
                                                            background: currentPage === pageNum 
                                                                ? 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' 
                                                                : 'white',
                                                            color: currentPage === pageNum ? 'white' : '#495057',
                                                            fontWeight: currentPage === pageNum ? '600' : '500',
                                                            minWidth: '32px',
                                                            transition: 'all 0.3s ease',
                                                            boxShadow: currentPage === pageNum ? '0 2px 8px rgba(240, 147, 251, 0.4)' : 'none'
                                                        }}
                                                    >
                                                        {pageNum}
                                                    </button>
                                                </li>
                                            ))}
                                            
                                            {/* Next Button */}
                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                <button 
                                                    className="page-link"
                                                    onClick={() => setCurrentPage(currentPage + 1)}
                                                    disabled={currentPage === totalPages}
                                                    style={{
                                                        padding: '4px 10px',
                                                        fontSize: '12px',
                                                        borderRadius: '5px',
                                                        border: '1px solid #dee2e6',
                                                        background: currentPage === totalPages ? '#e9ecef' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                        color: currentPage === totalPages ? '#6c757d' : 'white',
                                                        fontWeight: '500',
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                >
                                                    Next
                                                </button>
                                            </li>
                                            
                                            {/* Last Button */}
                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                <button 
                                                    className="page-link"
                                                    onClick={() => setCurrentPage(totalPages)}
                                                    disabled={currentPage === totalPages}
                                                    style={{
                                                        padding: '4px 10px',
                                                        fontSize: '12px',
                                                        borderRadius: '5px',
                                                        border: '1px solid #dee2e6',
                                                        background: currentPage === totalPages ? '#e9ecef' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                        color: currentPage === totalPages ? '#6c757d' : 'white',
                                                        fontWeight: '500',
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                >
                                                    Last
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        )}

                        {/* Summary */}
                        <div className="mt-3 p-3 bg-light-orange border rounded">
                            <div className="row">
                                <div className="col-md-4 text-center">
                                    <h6>Total Records</h6>
                                    <h4 className="text-warning-dark">{filteredData.length}</h4>
                                </div>
                                <div className="col-md-4 text-center">
                                    <h6>Total Amount</h6>
                                    <h4 className="text-danger">
                                        ฿ {filteredData.reduce((sum, item) => {
                                            const amount = item.amount || 0;
                                            return sum + parseFloat(amount);
                                        }, 0).toLocaleString('th-TH', { minimumFractionDigits: 2 })}
                                    </h4>
                                </div>
                                <div className="col-md-4 text-center">
                                    <h6>Latest Payment</h6>
                                    <h4 className="text-warning-dark">
                                        {filteredData.length > 0 ? new Date(filteredData[0].payment_date).toLocaleDateString('th-TH') : '-'}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </CardComponent>
                </div>
            </div>

            {/* Edit Payment Voucher Modal - Ant Design */}
            <Modal
                title={<><EditOutlined /> Edit Payment Voucher {editingVoucher && `PV-${editingVoucher.id}`}</>}
                open={showEditModal}
                onCancel={() => {
                    setShowEditModal(false);
                    editForm.resetFields();
                }}
                footer={null}
                width={800}
                destroyOnClose
            >
                <Form
                    form={editForm}
                    layout="vertical"
                    onFinish={handleUpdateVoucher}
                >
                    <Row gutter={16}>
                        <Col xs={24} md={12}>
                            <Form.Item
                                label={<><UserOutlined /> Supplier</>}
                                name="supplier_id"
                                rules={[{ required: true, message: 'Please select a supplier' }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select Supplier"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={suppliers.map(supplier => ({
                                        value: supplier.id,
                                        label: supplier.name
                                    }))}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                label={<><CalendarOutlined /> Payment Date</>}
                                name="payment_date"
                                rules={[{ required: true, message: 'Please select payment date' }]}
                            >
                                <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                label={<><DollarOutlined /> Amount</>}
                                name="amount"
                                rules={[{ required: true, message: 'Please enter amount' }]}
                            >
                                <InputNumber
                                    style={{ width: '100%' }}
                                    min={0}
                                    step={0.01}
                                    precision={2}
                                    placeholder="Enter amount"
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                label={<><DollarOutlined /> Discount Amount</>}
                                name="discount_amount"
                            >
                                <InputNumber
                                    style={{ width: '100%' }}
                                    min={0}
                                    step={0.01}
                                    precision={2}
                                    placeholder="Enter discount amount"
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                label="Payment Mode"
                                name="payment_mode"
                                rules={[{ required: true, message: 'Please select payment mode' }]}
                            >
                                <Select
                                    placeholder="Select Mode"
                                    options={paymentModes.map(mode => ({
                                        value: mode.value,
                                        label: mode.label
                                    }))}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                noStyle
                                shouldUpdate={(prevValues, currentValues) => prevValues.payment_mode !== currentValues.payment_mode}
                            >
                                {({ getFieldValue }) => {
                                    const paymentMode = getFieldValue('payment_mode');
                                    const requiresBank = paymentModes.find(m => m.value === paymentMode)?.requiresBank;
                                    
                                    return requiresBank ? (
                                        <Form.Item
                                            label={<><BankOutlined /> Bank Account</>}
                                            name="bank_account_id"
                                            rules={[{ required: true, message: 'Please select bank account' }]}
                                        >
                                            <Select
                                                placeholder="Select Bank Account"
                                                options={bankAccounts.map(account => ({
                                                    value: account.id,
                                                    label: `${account.account_name} - ${account.account_number}`
                                                }))}
                                            />
                                        </Form.Item>
                                    ) : null;
                                }}
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                label="Reference Number"
                                name="reference_number"
                            >
                                <Input placeholder="Enter reference number" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                noStyle
                                shouldUpdate={(prevValues, currentValues) => prevValues.payment_mode !== currentValues.payment_mode}
                            >
                                {({ getFieldValue }) =>
                                    getFieldValue('payment_mode') === 'Cheque' ? (
                                        <Form.Item
                                            label="Cheque Number"
                                            name="cheque_number"
                                        >
                                            <Input placeholder="Enter cheque number" />
                                        </Form.Item>
                                    ) : null
                                }
                            </Form.Item>
                        </Col>

                        <Col xs={24}>
                            <Form.Item
                                label={<><FileTextOutlined /> Description</>}
                                name="description"
                            >
                                <Input.TextArea rows={2} placeholder="Enter description" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                label="Invoice Numbers"
                                name="invoice_numbers"
                            >
                                <Input placeholder="Comma separated invoice numbers" />
                            </Form.Item>
                        </Col>

                        <Col xs={24}>
                            <Form.Item
                                label="Remarks"
                                name="remarks"
                            >
                                <Input.TextArea rows={2} placeholder="Enter remarks" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item style={{ marginBottom: 0, marginTop: 16 }}>
                        <Space style={{ float: 'right' }}>
                            <Button
                                icon={<CloseOutlined />}
                                onClick={() => {
                                    setShowEditModal(false);
                                    editForm.resetFields();
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                icon={<SaveOutlined />}
                                loading={loading}
                            >
                                Update Voucher
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Modal>
        </Layout>
    );
}
